import config from 'config';
import { put, takeLatest } from 'redux-saga/effects';
import NetworkHandler from 'utils/network';
import NotificationHandler from 'utils/notification';
import { actions as tripOfNoRevenueActions } from '../slices/TripStatisticsForNoRevenueTicketSlice';

function* getTripStatisticsForNoRevenueTicketReport({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('trip_statistics_for_no_revenue')}/${filters.route_id}/no-revenue`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: tripOfNoRevenueActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripOfNoRevenueActions.get_list_failed.type, payload: error });
    }
}

function* exportTripStatisticsyReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('trip_statistics_for_no_revenue')}/${filters.route_id}/no-revenue`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: tripOfNoRevenueActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripOfNoRevenueActions.export_list_failed.type, payload: error });
    }
}


function* watchRequestDetail() {
    yield takeLatest(tripOfNoRevenueActions.get_list, getTripStatisticsForNoRevenueTicketReport);
    yield takeLatest(tripOfNoRevenueActions.export_list, exportTripStatisticsyReport);
}

export default watchRequestDetail;
